import { render, staticRenderFns } from "./CTV01.vue?vue&type=template&id=5dc86f7c"
import script from "./CTV01.vue?vue&type=script&lang=js"
export * from "./CTV01.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports